import { MyDocument } from 'common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { fetchMyDocuments } from './MyDocumentsSlice';
import { MyDocumentsDataSelector } from './MyDocumentsDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';

export function useMyDocuments(): AbstractDataState<Array<MyDocument>, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMyDocuments, MyDocumentsDataSelector);
}
